import styled from "styled-components";

const RecipePage = styled.div`

  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;
  @media (min-width: 769px) {
    margin-left: 60px;
  }
`;

export default RecipePage;
